export interface InputMaskEl extends HTMLInputElement {
  inputmask: InputMaskTypes;
}

export type InputValue = string | number | null;

export interface IMaskValidation {
  value: string;
  errorMessage: string;
}

export interface ILengthValidation {
  value: number;
  errorMessage: string;
}

export interface InputMaskTypes {
  isValid: () => boolean;
  unmaskedvalue: () => string;
  getemptymask: any;
  getmetadata: any;
  hasMaskedValue: () => boolean;
  isComplete: () => boolean;
  mask: any;
  option: any;
  remove: any;
  setValue: any;
}

export enum EventTypes {
  AUTO = "auto",
  MANUAL = "manual",
}

export enum Validations {
  verify = "verify",
  mask = "mask",
  regex = "regex",
  required = "required",
  min = "min",
  max = "max",
}

export enum InputTypes {
  PASSWORD = "password",
  SIMPLE = "input-simple",
  CHECK_BOX = "input-checkbox",
  TEXT = "input-text-field",
  TREE = "input-select-tree",
  DATE = "input-date",
  IMAGE = "input-image",
  FILE = "input-file",
  RADIO = "input-radio",
  ROW = "input-row",
  HINT = "input-hint",
  DROPDOWN = "input-dropdown",
  RANGE = "input-range",
  GROUP = "input-group",
  MAX = "max",
  MIN = "min",
}
